import { render, staticRenderFns } from "./VideoCrawlerSettingsToggle.vue?vue&type=template&id=1edd66f6&scoped=true&"
import script from "./VideoCrawlerSettingsToggle.vue?vue&type=script&lang=js&"
export * from "./VideoCrawlerSettingsToggle.vue?vue&type=script&lang=js&"
import style0 from "./VideoCrawlerSettingsToggle.vue?vue&type=style&index=0&id=1edd66f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd66f6",
  null
  
)

export default component.exports